/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { destroyComment } from 'store/modules/bidding_store/actions';
import SquareLoader from 'components/atoms/square_loader';
import { deleteTaskComment } from 'store/modules/management_store/actions';
import { destroyCommentImminence } from 'store/modules/get_dados_imminence_store/actions';
import { destroyCommentBulletin } from 'store/modules/bulletins_store/actions';
import { Container } from './styles';

interface CommentItemProps {
  id: number;
  contact_client_id: number;
  contact_client_nome: string;
  created_at: string;
  message: string;
  biddingId?: string;
  taskId?: number;
  commentSource: 'biddings' | 'management' | 'imminence' | 'bulletin';
  bulletinFilterId?: number;
}

const CommentItem = (props: CommentItemProps) => {
  const {
    id,
    contact_client_id,
    contact_client_nome,
    created_at,
    message,
    biddingId = '',
    commentSource,
    taskId = 0,
    bulletinFilterId = 0,
  } = props;

  const dispatch = useDispatch();
  moment.locale('pt-br');

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [loadingBars, setLoadingBars] = useState<string>('invisible');
  const [commentDelete, setCommentDelete] = useState<string>('visible');

  const deleteBiddingComment = () => {
    setLoadingBars('visible');
    setCommentDelete('invisible');
    dispatch(destroyComment(biddingId, id));
  };

  const deleteManagementComment = () => {
    setLoadingBars('visible');
    setCommentDelete('invisible');
    dispatch(deleteTaskComment(id, taskId));
  };

  const deleteImminenceComment = () => {
    setLoadingBars('visible');
    setCommentDelete('invisible');
    dispatch(destroyCommentImminence(biddingId, id));
  };

  const deleteBulletinComment = () => {
    setLoadingBars('visible');
    setCommentDelete('invisible');
    dispatch(destroyCommentBulletin(biddingId, id, bulletinFilterId));
  };
  return (
    <Container className="row justify-content-start mb-2 px-3">
      <div className="col-md-12 comment pt-2 pb-2">
        <div className="row pt-1">
          <div
            className={`col-md-6 col-12 font-weight-bold ${
              profile.id === contact_client_id ? 'comment-name-me' : 'comment-name-other'
            }`}
          >
            {contact_client_nome}
          </div>
          <div className="col-md-6 col-12 text-left text-md-right comment-info">
            <span className="comment-date">{moment.parseZone(created_at).format('L [às] LT')}</span>
            {profile.id === contact_client_id && (
              <div className="delete-link ml-1">
                |
                <button
                  type="button"
                  className="hover-pointer ml-1 btn-link border-0 p-0"
                  title="Excluir comentário"
                  onClick={() => {
                    if (commentSource === 'biddings') deleteBiddingComment();
                    if (commentSource === 'management') deleteManagementComment();
                    if (commentSource === 'imminence') deleteImminenceComment();
                    if (commentSource === 'bulletin') deleteBulletinComment();
                  }}
                >
                  <span className={`comment-delete ${commentDelete}`}>Excluir</span>
                  <SquareLoader customClass={`${loadingBars} delete-comment-loading`} />
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="row pb-1 pt-1">
          <div className="col-md-12">{message}</div>
        </div>
      </div>
    </Container>
  );
};

export default CommentItem;
